<template>
  <v-menu v-if="isAuth && (shouldRenderMenu || checkGrantedWorkspace)" offset-y left v-model="menu" rounded="xl"
    class="relative  z-[100000000] w-[305px] h-[167px]  rounded-[20px] shadow" max-width="350px">
    <template v-slot:activator="{ on }">
      <div v-on="on" flat class="cursor-pointer" :max-width="isMobile ? '250px' : '600px'" :disabled="isLoading">
        <v-skeleton-loader v-if="isLoading" type="list-item-avatar"></v-skeleton-loader>
        <v-list-item class="flex items-center justify-center workspace-menu-item">
          <div class="w-[171px] h-[39px] rounded-[32px] flex items-center justify-between my-2 pa-2" style="border: 1px solid #e0e0e0;"> 
            <div class="flex items-center">
              <v-list-item-avatar size="24" class="mr-2">
                <img v-if="currentWorkspaceLogo" :src="currentWorkspaceLogo" alt="Workspace Logo" class="h-6 w-6 rounded-full">
                <v-icon v-else size="24" color="purple">mdi-briefcase-outline</v-icon>
              </v-list-item-avatar>
              <div> 
                <div class="truncate text-white text-base font-bold">{{ trimmedWorkspaceName }}</div>
                <!-- <div class="text-xs text-slate-500 font-medium ">Workspace</div> -->
              </div>
            </div>
            <div class="mr-1">
              <v-icon color="grey darken-1">mdi-chevron-down</v-icon> 
            </div>
          </div>
        </v-list-item>
      </div>
    </template>
    <v-list class="pt-0 workspace-list-standard"> 
      <v-list-item-group class="p-2" :value="WID" mandatory> 
        <v-list-item v-for="(item, i) in workspaces" :key="i" class="pb-0 change-workspace" :value="item.id"
          @click="changeWorkspace(item)" :class="{ 'v-list-item--active primary--text': checkSelected(item.id) }">
          <v-list-item-avatar>
            <img v-if="item.logo_original" :src="item.logo_original" alt="Workspace Logo" class="h-8 w-8 rounded-full">
            <v-icon v-else color="purple">mdi-briefcase-outline</v-icon>
          </v-list-item-avatar>
          <div class="text-sm font-medium text-slate-800"> 
            {{ truncateName(item.name) }}
            <div v-if="item.type == 'user'" class="text-xs font-normal text-slate-500">
              Owner
            </div>
            <div v-else class="text-xs font-normal text-slate-500">Shared</div>
          </div>
          <v-list-item-content>
            <v-list-item-title></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.type == 'user'">
            <div class="relative" v-on:click.stop>
              <button @click="toggleDropdown(i)">
                <v-icon color="grey darken-1">mdi-dots-vertical</v-icon> 
              </button>
              <div v-if="openDropdownIndex === i"
                class="absolute right-0 top-full z-40 mt-1 w-40 space-y-1 rounded-md border border-gray-200 bg-white p-1.5 shadow-lg">
                <button
                  class="flex w-full items-center gap-2 rounded-sm py-1.5 px-2 text-left text-sm text-slate-700 hover:bg-gray-100"
                  @click="populateWorkspaceName(item)">
                  <v-icon small class="mr-2">mdi-pencil-outline</v-icon> 
                  Edit
                </button>
                <button
                  class="flex w-full items-center gap-2 rounded-sm py-1.5 px-2 text-left text-sm text-red-500 hover:bg-red-50"
                  @click="deleteWorkspace(item)" v-if="item.wid !== 'default'">
                  <v-icon small class="mr-2">mdi-delete-outline</v-icon> 
                  Delete
                </button>
              </div>
            </div>
          </v-list-item-action>
        </v-list-item>

        <div class="flex items-center justify-start pa-2 mt-2 rounded-lg cursor-pointer hover:bg-gray-100" 
          @click="checkWorkspaceLimit" v-if="(shouldRenderMenu)">
          <v-icon color="primary" class="mr-3">mdi-plus-box</v-icon>
          <div class="text-sm font-medium text-primary">Add workspace</div> 
        </div>

        <v-dialog v-model="dialog" persistent max-width="400px">
          <addworkspace title="Add workspace" @close="dialog = false" @submit="addWorkspace()">
            <addwrokspaceinput-vue label="Brand/Business Name" v-model="brandName" rules="maxworkspacename"
              :error-messages="errorMessage" />
            <v-card class="cursor-pointer mt-2">
              <v-text-field v-model="website" label="Website/Social Profile/Page URL" prepend-icon="mdi-web" type="url"
                class="ml-2 cursor-pointer" />
            </v-card>

            <!-- Business Description Field -->
            <v-card class="cursor-pointer mt-2">
              <v-textarea v-model="businessDescription" label="Business Description" prepend-icon="mdi-text" auto-grow
                />
            </v-card>


            <!-- <v-card class="cursor-pointer mt-2">
              <v-text-field v-model="primaryEmail" label="Primary Email" prepend-icon="mdi-email" type="email"
                class="ml-2 cursor-pointer"></v-text-field>
            </v-card> -->
            <v-card class="cursor-pointer mt-2 mb-2">
              <v-file-input v-model="brandLogo" label="Upload Brand Logo" prepend-icon="mdi-upload" accept="image/*"
                class="ml-2 cursor-pointer"></v-file-input>
            </v-card>
            <v-card class="mt-2 p-2">
              <v-combobox v-model="countryCode" :items="countryOptions" label="Country" item-text="name"
                item-value="value" clearable return-object hide-selected dense >
              </v-combobox>
            </v-card>
            <v-card class="mt-2 p-2">
              <v-combobox
  v-model="timezone"
  :items="timezoneOptions"
  label="Timezone"
  item-text="label" 
  item-value="value" 
  prepend-icon="mdi-earth"
  clearable
  return-object
  hide-selected
  dense
  class="ml-2 cursor-pointer"
>
</v-combobox>
            </v-card>
            <v-card class="cursor-pointer mt-2">
  <v-text-field
    v-model="primaryEmail"
    label="Primary Email"
    prepend-icon="mdi-email"
    type="email"
    class="ml-2 cursor-pointer"
  ></v-text-field>
</v-card>
            <v-checkbox v-model="sendWeeklyReport"
              label="Send weekly social media performance report to primary email"></v-checkbox>
              <vue-tel-input-vuetify
  class="bg-[#f2f6fa] flex flex-row gap-3 outline-[#8056DE] md:w-[309px] h-14 rounded-[26px] mt-2 pb-3 mb-3"
  mode="international"
  v-model="phone_number"
  :validate-on-blur="true"
>
  <input
    type="text"
    class="bg-[#f2f6fa] flex flex-row gap-3 w-full outline-[#8056DE] md:w-[309px] h-12 items-start rounded-[26px]"
    placeholder="Phone Number"
  />
</vue-tel-input-vuetify>

            <v-checkbox v-model="sendWeeklyReportonphone"
              label="Send weekly social media performance report to primary phone number"></v-checkbox>
          </addworkspace>
        </v-dialog>

        <v-dialog v-model="limitDialog" persistent max-width="400px">
          <v-card>
            <v-card-title class="headline">Cannot add workspace</v-card-title>
            <v-card-text>
              You've reached the limit to add more brands. Please reach out to
              us at
              <span>
                <a href="mailto:fly@zoomlocal.in">fly@zoomlocal.in</a>
              </span>
              to get more brands added.
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="limitDialog = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-list-item-group>

      <template>
        <v-dialog v-model="nameDialog" persistent max-width="470px">
          <dialog-workspace title="Edit your workspace" @close="closeNameDialog" @submit="editWorkspace">
            <v-card class="cursor-pointer">
              <v-text-field v-model="workspaceName" label="Workspace Name" prepend-icon="mdi-briefcase"
                class="ml-2 cursor-pointer"></v-text-field>
            </v-card>
            <v-card class="cursor-pointer mt-2">
              <v-text-field v-model="website" label="Website/Social Profile/Page URL" prepend-icon="mdi-web" type="url"
                class="ml-2 cursor-pointer" />
            </v-card>
            <!-- Business Description Field -->
            <v-card class="cursor-pointer mt-2">
              <v-textarea v-model="businessDescription" label="Business Description" prepend-icon="mdi-text"
                auto-grow />
            </v-card>
            <!-- Brand Logo Field with Preview and Edit -->
            <v-card class="cursor-pointer mt-2 mb-2">
              <div class="flex">
                <div class="logo-preview-container" style="position: relative; width: 100px; height: 100px;">
                  <img
                    :src="editableWorkspace.logo_original || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTi1p8_WaFcY_wt5qn3Vd0_VpkTtyo9AFeSB0PT3iVz1A&s'"
                    alt="Workspace Logo" class="logo-preview" style="width: 100%; height: 100%; border-radius: 50%;">
                  <v-btn icon @click.stop="triggerFileInput"
                    style="position: absolute; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5);">
                    <v-icon color="white">mdi-pencil</v-icon>
                  </v-btn>
                </div>
                <!-- Hidden File Input -->
                <input type="file" ref="fileInput" @change="handleLogoChange" accept="image/*" style="display: none;">
                <div>Update Brand logo</div>
              </div>
            </v-card>

            <v-card class="mt-2 p-2">
              <v-combobox v-model="countryCode" :items="countryOptions" label="Country" item-text="name"
                item-value="value" clearable return-object hide-selected dense>
              </v-combobox>
            </v-card>
            <v-card class="mt-2 p-2">
              <v-combobox v-model="timezone" :items="timezoneOptions" label="Timezone" item-text="label"
                item-value="value" prepend-icon="mdi-earth" clearable return-object hide-selected dense
                class="ml-2 cursor-pointer">
              </v-combobox>
            </v-card>
            <v-card class="cursor-pointer mt-2">
  <v-text-field
    v-model="primaryEmail"
    label="Primary Email"
    prepend-icon="mdi-email"
    type="email"
    class="ml-2 cursor-pointer"
  ></v-text-field>
</v-card>
            <v-checkbox v-model="sendWeeklyReport"
              label="Send weekly social media performance report to primary email"></v-checkbox>
              <vue-tel-input-vuetify
  class="bg-[#f2f6fa] flex flex-row gap-3 outline-[#8056DE] md:w-[309px] h-14 rounded-[26px] mt-2 pb-3 mb-3"
  mode="international"
  v-model="phone_number"
>
  <input
    type="text"
    class="bg-[#f2f6fa] flex flex-row gap-3 w-full outline-[#8056DE] md:w-[309px] h-12 items-start rounded-[26px]"
    placeholder="Phone Number"
  />
</vue-tel-input-vuetify>

            <v-checkbox v-model="sendWeeklyReportonphone"
              label="Send weekly social media performance report to primary phone number"></v-checkbox>
          </dialog-workspace>
        </v-dialog>

      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { onAuthStateChanged, signOut } from "firebase/auth";
import UserLogo from "./UserLogo.vue";


import {
  auth,
  colUsers,
  db,
  flyplans,
  functions,
  getSharedWorkspaceRef,
  getWorkspaceDocRef,
  getWorkspaceRef,
} from "@/utils/firebase.utils";
import {
  onSnapshot,
  addDoc,
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import DialogCard from "@/components/ui/DialogCard.vue";
import InputField from "./ui/form/InputField.vue";
import DialogWorkspace from "@/components/ui/DialogWorkspace.vue";
import Inputworkspace from "@/components/ui/form/Inputworkspace.vue";
import Addworkspace from "./ui/Addworkspace.vue";
import AddwrokspaceinputVue from "./ui/form/Addwrokspaceinput.vue";
import { mapDocs } from "@/utils/common.utils";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ProfileSelectfield from "../components/ui/form/ProfileSelectfield";
import countries from "i18n-iso-countries";
import moment from 'moment-timezone';
import { httpsCallable } from "firebase/functions";

export default {
  components: {
    UserLogo,
    DialogCard,
    InputField,
    DialogWorkspace,
    Inputworkspace,
    Addworkspace,
    AddwrokspaceinputVue,
    ProfileSelectfield
  },
  data() {
    return {
      users: [],
      workspaces: [],
      unsubscribe:null,
      unsubscribe1:null,
      menu: false,
      subscribe: null,
      isLoading: false,
      dialog: false,
      limitDialog: false,
      nameDialog: false,
      workspaceName: "",
      brandName: "",
      editableWorkspace: {},
      errorMessage: "",
      showAddBtn: true,
      shouldRenderMenu: false,
      brandLogo: null,
      primaryEmail: "",
      emailRules: [
      v => !!v || 'Email is required', // Check for non-empty input
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid' // Validate email format
    ],
    phoneRules: [
      v => !!v || 'Phone number is required', // Checks for non-empty input
      v => (v && v.length >= 10) || 'Phone number must be valid' // Additional validation to ensure length
    ],
      sendWeeklyReport: true,
      phone_number: "",
      sendWeeklyReportonphone: true,
      openDropdownIndex: null,
      website: '',
      websiteError: "",
      businessDescription: '',
      countryCode: '',
      countryOptions: null,
      timezone: '',  // To store the selected timezone
      timezones: moment.tz.names(),
      isEditingWorkspace: false,
      timezone: null, // This will hold the selected timezone
      timezoneOptions: this.getTimezoneOptions(),
    };
  },
  watch: {
    countryCode(newCountryCode) {
    if (newCountryCode) {
      this.updateTimezonesForCountry(newCountryCode); // Update timezones based on country selection
    }
  },
    website(value, oldValue) {
      // Check if the value is already starting with http or https
      if (value && !value.startsWith("http") && oldValue !== value) {
        this.website = `https://${value}`;
      }
      this.validateWebsite();
    },
    menu(newVal) {
      if (!newVal) {
        this.openDropdownIndex = null;
      }
    },
    brandName: {
      handler(val) {
        this.errorMessage = "";
      },
      deep: true,
    },
  },
  computed: {
    async checkGrantedWorkspace() {
      if (!auth.currentUser) {
      console.error('User is not authenticated');
      return false; 
    }
      if (!this.shouldRenderMenu) {
        this.workspaces = this.workspaces.filter((i) => ((i.uid !== auth.currentUser.uid) || (i.uid == auth.currentUser.uid && i.wid == 'default')))
        return true;
      }
      return false
    },
    currentWorkspace() {
      let id = localStorage.getItem("CURRENT_WORKSPACE_ID") || `default__${this.uid}`;
      return this.workspaces.find((i) => i.id === id) || {};
    },
    trimmedWorkspaceName() {
      const name = this.currentWorkspace.name;
      if (name && name.length > 13) {
        return name.slice(0, 13) + "...";
      }
      return name ? name : "";
    },
    currentWorkspaceLogo() {
      return this.currentWorkspace.logo_original; // Returns the logo URL of the current workspace
    },
    showUserLogoAndName() {
      return window.innerWidth > 480;
    },
    selectedWorkspace() {
      let workspace = {};
      for (const key in this.workspaces) {
        const checkwid = this.checkWorkspace(this.workspaces[key].id);
        if (
          checkwid &&
          this.workspaces[key].id == `${this.WID}__${this.currentUID}`
        ) {
          workspace = this.workspaces[key];
        }
        if (this.workspaces[key].id === this.WID) {
          workspace = this.workspaces[key];
        }
      }
      return workspace;
    },
  },

  methods: {
    truncateName(name) {
    return name.length > 32 ? name.slice(0, 32) + '...' : name;
  },
    validateWebsite() {
      // Check if the URL starts with https
      if (!this.website.startsWith("https://")) {
        this.websiteError = 'Website must start with "https://"';
        // If it starts with http but not https, let it be (to handle http cases if needed)
        if (this.website.startsWith("http://")) {
          this.websiteError = 'Secure website URL should start with "https://"';
        }
      } else {
        this.websiteError = ""; // Clear error if URL is correct
      }
    },
    getTimezoneOptions() {
      return moment.tz.names().map((tz) => {
        const tzOffset = moment.tz(tz).utcOffset(); // Get timezone offset in minutes
        const offsetHours = Math.floor(Math.abs(tzOffset) / 60);
        const offsetMinutes = Math.abs(tzOffset) % 60;
        const offsetSign = tzOffset >= 0 ? '+' : '-';
        const formattedOffset = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`; // Format as +hh:mm or -hh:mm

        return {
          label: `(UTC ${formattedOffset}) ${tz}`,
          value: tz,
        };
      });
    },

    // trimmedWorkspaceName() {
    //   return this.selectedWorkspace.name.slice(0, 12);
    // },

    initCountries() {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

  // Create a country options array with full names and codes
  this.countryOptions = Object.entries(countries.getNames("en")).map(
    ([code, name]) => ({
      name: name,
      value: code,
    })
  );
},
updateTimezonesForCountry(country) {
    if (country && country.value) {
      // Get the timezones based on the selected country code
      const timezones = moment.tz.zonesForCountry(country.value.toUpperCase());
      this.timezoneOptions = timezones.map(zone => ({
        label: `(UTC ${moment.tz(zone).format('Z')}) ${zone}`,  // Format timezone label
        value: zone   // The actual value bound to v-model
      }));

      // If only one timezone is available, auto-select it
      if (this.timezoneOptions.length === 1) {
        this.timezone = this.timezoneOptions[0];  // Bind the entire object with label and value
      } else {
        this.timezone = null;  // Clear the timezone if there are multiple options
      }
    } else {
      // If no country is selected, show all available timezones
      const allTimezones = moment.tz.names();
      this.timezoneOptions = allTimezones.map(zone => ({
        label: `(UTC ${moment.tz(zone).format('Z')}) ${zone}`,  // Format timezone label
        value: zone   // The actual value bound to v-model
      }));

      this.timezone = null; // Clear selected timezone when country is deselected
    }
  },
getCountryObject(countryCode) {
  // Find and return the country object (name and code) based on the code
  return this.countryOptions.find((country) => country.value === countryCode);
},

    checkUser(wid) {
      const checkwid = this.checkWorkspace(wid);
      if (checkwid) return false;
      else return true;
    },
    checkSelected(wid) {
      // console.log(wid,"this is the wid")
      const checkwid = this.checkWorkspace(wid);
      if (
        (checkwid && wid == `${this.WID}__${this.currentUID}`) ||
        (!checkwid &&
          wid == this.WID &&
          this.currentUID == this.currentOriginalUID)
      )
        return true;
      else return false;
    },
    checkWorkspace(wid) {
      if (wid?.includes("__")) {
        const parts = wid?.split("__");
        if (parts?.length === 2) {
          const wid = parts[0];
          const senderId = parts[1];
          return { wid, senderId };
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    toggleDropdown(index) {
      // Toggle dropdown visibility based on index
      this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
    },
    async deleteWorkspace(item) {
      if (
        confirm(`Are you sure you want to delete the workspace "${item.name}"?`)
      ) {
        try {
          const userId = auth.currentUser.uid;
          const workspaceDocRef = doc(
            db,
            "users",
            userId,
            "fly_workspaces",
            item.wid
          );

          // Fetch all subcollections and delete them
          const subcollections = await getDocs(
            collection(workspaceDocRef, "brand")
          );
          const deletePromises = subcollections.docs.map((subDoc) =>
            deleteDoc(subDoc.ref)
          );

          await Promise.all(deletePromises);

          // Now delete the workspace document itself
          await deleteDoc(workspaceDocRef);

          this.$snackbar.show("Workspace deleted successfully");
          this.listenUsers();
        } catch (error) {
          console.error("Error deleting workspace: ", error);
          this.$snackbar.show("Failed to delete workspace. Please try again.");
        }
      }
    },
    closeNameDialog() {
      this.nameDialog = false;
      this.isEditingWorkspace = false; // Reset on dialog close
    },
    async populateWorkspaceName(item) {
      this.menu = false;

      try {
        const workspaceDocRef = doc(db, "users", this.uid, "fly_workspaces", item.wid);
        const workspaceDoc = await getDoc(workspaceDocRef);
        if (workspaceDoc.exists()) {
          const workspaceData = workspaceDoc.data();
          this.workspaceName = workspaceData.name;
          this.website = workspaceData.websiteLink;  // Update this line
          this.countryCode = workspaceData.countryCode;
          this.businessDescription = workspaceData.businessDescription;  // Update this line
          this.primaryEmail = workspaceData.primary_email;
          this.sendWeeklyReport = workspaceData.on_primary_email_send;
          this.phone_number = workspaceData.phone_number;
          this.timezone = workspaceData.timezone;
          this.sendWeeklyReportonphone = workspaceData.on_phone_number_send;
          this.editableWorkspace = { ...workspaceData, id: item.id, logo_original: workspaceData.logo_original || null };

          // Open the dialog
          this.nameDialog = true;
          this.isEditingWorkspace = true;
        } else {
          this.$snackbar.show("Workspace does not exist");
        }
      } catch (error) {
        console.error("Failed to fetch workspace data: ", error);
        this.$snackbar.show("Failed to fetch workspace data. Please try again.");
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();  // Ensure 'fileInput' is the correct ref name
    },
    handleLogoChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.brandLogo = file;
        // Optionally, read and preview the image immediately
        const reader = new FileReader();
        reader.onload = (e) => {
          this.editableWorkspace.logo_original = e.target.result;  // Update the preview immediately
        };
        reader.readAsDataURL(file);
      }
    },
    getVersion() {
      if (process.env.VUE_APP_ENV === "production") {
        return process.env.VUE_APP_VERSION;
      } else {
        return process.env.VUE_APP_ENV + "-" + process.env.VUE_APP_VERSION;
      }
    },
    logout() {
      signOut(auth);
    },
    clearAllReportCaches(currentUID) {
      /* ---------- Reviews Insights (single key) ---------- */
      localStorage.removeItem("gmbReviewReportCache");

      /* ---------- Reviews Dashboard (one key per UID+WIDs) ---------- */
      // any key that begins with the known prefix for this user
      const dashPrefix = `reviewDashboardCache_${currentUID}_`;
      Object.keys(localStorage)
        .filter(k => k.startsWith(dashPrefix))
        .forEach(k => localStorage.removeItem(k));

      /* ---------- Search Insights (fixed session keys) ---------- */
      [
        "gmbsearchReportStartMonthYear",
        "gmbsearchReportEndMonthYear",
        "gmbsearchReportSelectedStore",
        "gmbsearchReportData",
        "gmbsearchReportLastGeneratedAt"
      ].forEach(k => sessionStorage.removeItem(k));
    },
    async changeWorkspace(workspace) {
      // console.log("Switching to workspace:", workspace);
      // console.log("name",workspace.id,workspace.name);

      if (this.$route.name == "create-post") {
        this.$confirm.show({
          message: `All changes will be lost. Are you sure you want to switch workspace?`,
          onConfirm: async () => {
            // 1. clear every cached report
            this.clearAllReportCaches(this.currentUID);
            localStorage.setItem("CURRENT_WORKSPACE_ID", workspace.id);
            localStorage.setItem("CURRENT_WORKSPACE", JSON.stringify(workspace));
            this.$store.commit("SET_CURRENT_WORKSPACE", workspace);
            
            // Emit workspace change event for components to react to
            this.$root.$emit('workspace-changed', workspace.id);
            
            // Trigger a full page reload after the router has navigated to "/dashboard"
            window.location.href = "/create";
          },
        });
      } else {
        // 1. clear every cached report
        this.clearAllReportCaches(this.currentUID);
        localStorage.setItem("CURRENT_WORKSPACE_ID", workspace.id);
        localStorage.setItem("CURRENT_WORKSPACE", JSON.stringify(workspace));
        this.$store.commit("SET_CURRENT_WORKSPACE", workspace);
        
        // Emit workspace change event for components to react to
        this.$root.$emit('workspace-changed', workspace.id);
        
         this.$nextTick(() => {
          if (this.$route.name == "repost" || this.$route.name == "edit-post" || this.$route.name == "draft-post") {
            window.location.href = "/create";
          }
          if(this.$route.name == "post"){
            window.location.href = "/posts";
          }
          else location.reload();
        });
      }
    },

    async editWorkspace() {
      // console.log("Adding workspace with", this.website, this.businessDescription);
      this.$loader.show("Updating the workspace");
      this.menu = false;
      try {
        let workspaceRef = doc(db, "users", this.uid, "fly_workspaces", this.editableWorkspace.id.split('__')[0]);
        let logoURL = this.editableWorkspace.logo_original;

        // Ensure updateData is declared before being used
        const updateData = {};  // Initialize updateData as an empty object

        // Only update the logo URL if a new brand logo has been provided
        if (this.brandLogo && typeof this.brandLogo !== 'string') {
          const storageRef = getStorage();
          const logoRef = ref(storageRef, `logos/${this.currentUID}/${this.brandLogo.name}`);
          const snapshot = await uploadBytes(logoRef, this.brandLogo);
          logoURL = await getDownloadURL(snapshot.ref);
          updateData.logo_original = logoURL;  // Add logo URL to updateData
        }

        if (this.workspaceName) {
          updateData.name = this.workspaceName;
          updateData.brandName = this.workspaceName; // Synchronize brandName with workspaceName
        }
        if (this.website) updateData.websiteLink = this.website;  // Update website if changed
        if (this.businessDescription) updateData.businessDescription = this.businessDescription;  // Update description if changed
        if (this.primaryEmail) updateData.primary_email = this.primaryEmail;
        if (typeof this.sendWeeklyReport === 'boolean') updateData.on_primary_email_send = this.sendWeeklyReport;
        if (this.phone_number) updateData.phone_number = this.phone_number;
        if (typeof this.sendWeeklyReportonphone === 'boolean') updateData.on_phone_number_send = this.sendWeeklyReportonphone;
        if (this.countryCode) updateData.countryCode = this.countryCode;
        if (this.timezone) updateData.timezone = this.timezone;  // Add this line to update timezone

        // Perform the update if there are fields to update
        if (Object.keys(updateData).length > 0) {
          await updateDoc(workspaceRef, updateData);
          this.$snackbar.show("Workspace updated successfully");
        }

        // Clear input fields and close the dialog after successful update
        this.nameDialog = false; // Close the dialog
        this.clearEditFields();
        this.listenUsers(); // Refresh list to reflect changes
      } catch (error) {
        console.error("Error updating workspace: ", error);
        this.$snackbar.show("Failed to update workspace. Please try again.");
      }
      this.$loader.hide();
    },



    // Method to clear fields
    clearEditFields() {
      this.workspaceName = "";
      this.website = "";
      this.businessDescription = "";
      this.primaryEmail = "";
      this.sendWeeklyReport = false;
      this.phone_number = "";
      this.sendWeeklyReportonphone = false;
      this.brandLogo = null; // Clear brand logo if necessary
    },
    async populateWorkspaceFields() {
  console.log("called populateWorkspaceFields");
  try {
    // Assuming vm.uid is the user's UID
    const userRef = doc(db, "users", auth.currentUser.uid);
    const userDoc = await getDoc(userRef);
    console.log("user", userDoc);

    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log("User data:", userData);

      // Populate user-related fields (primaryEmail and phone number)
      this.primaryEmail = userData.email || "";
      this.phone_number = userData.phone_number || "";

      // Retrieve the default workspace data
      const workspaceRef = doc(
        db,
        "users",
        auth.currentUser.uid,
        "fly_workspaces",
        this.WID || "default"
      );
      const workspaceDoc = await getDoc(workspaceRef);

      if (workspaceDoc.exists()) {
        const workspaceData = workspaceDoc.data();

        // Auto-populate the country code, then convert it to the full country name
        const countryCode = workspaceData.countryCode || userData.country_code || "IN";  // Default to "IN"
        this.countryCode = this.getCountryObject(countryCode);  // Convert to full country name

        // Auto-populate the timezone with label and value
        if (workspaceData.timezone) {
          const tzName = workspaceData.timezone;
          const tzOffset = moment.tz(tzName).utcOffset();  // Get timezone offset in minutes
          const offsetHours = Math.floor(Math.abs(tzOffset) / 60);
          const offsetMinutes = Math.abs(tzOffset) % 60;
          const offsetSign = tzOffset >= 0 ? '+' : '-';
          const formattedOffset = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;

          this.timezone = {
            label: `(UTC ${formattedOffset}) ${tzName}`,
            value: tzName,
          };
        } else {
          this.timezone = null;  // Clear the timezone if none is stored
        }

        // Use user data if not defined in the workspace for primaryEmail and phone_number
        this.primaryEmail = this.primaryEmail || workspaceData.primary_email || "";
        this.phone_number = this.phone_number || workspaceData.phone_number || "";
      } else {
        console.log("Default workspace does not exist.");
      }
    } else {
      console.log("No user data found.");
    }
  } catch (error) {
    console.error("Error fetching workspace/user data: ", error);
    this.$snackbar.show(
      "Failed to fetch workspace/user data. Please try again."
    );
  }
}


,
async addWorkspace() {
  this.$loader.show("Creating the workspace");
  try {
    // Fetch user data and limit
    let userData = (await getDoc(doc(colUsers, this.currentUID))).data();
    const monthly_limit = userData.addon_monthly_credits?.brands || 0;
    let plan_data = (await getDoc(doc(flyplans, userData?.fly_plan))).data();
    let limit = (plan_data?.limits?.brands || 0) + monthly_limit;

    // Fetch workspaces and count total
    let workspaceRef = collection(db, "users", this.currentUID, "fly_workspaces");
    const workspaceSnapshot = await getDocs(workspaceRef);
    let totalWorkspaces = workspaceSnapshot.docs.length;

    // Check workspace limit
    if (!limit || (limit && totalWorkspaces < limit)) {
      // Check if a workspace with the same name exists
      const querySnapshot = await getDocs(workspaceRef);
      const workspaceExists = querySnapshot.docs.some(
        (doc) => doc.data().name === this.brandName && !doc.data().storeWorkspace
      );
      
      if (workspaceExists) {
        this.errorMessage = "Workspace already exists with this name";
      } else {
        // Upload brand logo and get the URL
        let logoURL = '';
        if (this.brandLogo) {
          const storageRef = getStorage();
          const logoRef = ref(storageRef, `logos/${this.currentUID}/${this.brandLogo.name}`);
          const snapshot = await uploadBytes(logoRef, this.brandLogo);
          logoURL = await getDownloadURL(snapshot.ref);
        }

        // Prepare data for creating a new workspace
        const workspaceData = {
          name: this.brandName,
          brandName: this.brandName,
          websiteLink: this.website || "", // Website link is optional, so provide an empty string as default
          businessDescription: this.businessDescription || "", // Optional field with default
          logo_original: logoURL,
          primary_email: this.primaryEmail || "", // Optional field with default
          on_primary_email_send: this.sendWeeklyReport,
          phone_number: this.phone_number || "", // Optional field with default
          on_phone_number_send: this.sendWeeklyReportonphone
        };

        // Conditionally add timezone and countryCode if they exist
        if (this.timezone && typeof this.timezone === 'object') {
          workspaceData.timezone = this.timezone.value;
        } else if (this.timezone) {
          workspaceData.timezone = this.timezone; // If it's already a string
        }

        if (this.countryCode && typeof this.countryCode === 'object') {
          workspaceData.countryCode = this.countryCode.value;
        } else if (this.countryCode) {
          workspaceData.countryCode = this.countryCode; // If it's already a string
        }

        // Create the workspace in Firestore
        const newWorkspaceRef = await addDoc(workspaceRef, workspaceData);

        const newWorkspaceId = newWorkspaceRef.id;
        let payload = {
          uid: this.currentUID,
          wid: newWorkspaceId,
          url: this.website,
          description: this.businessDescription,
        };

        // Optionally generate AI content if the business description is provided
        // if (this.businessDescription) {
        //   const generateAiContent = httpsCallable(functions, "generateAiContentFunction");
        //   await generateAiContent(payload);
        // }

        // Show success and reset fields
        this.$snackbar.show("Workspace created successfully");
        this.listenUsers();
        this.dialog = false;
        this.resetFormFields();
      }
    } else {
      this.$alert.show("Workspace limit reached. Please try again.");
    }
  } catch (error) {
    console.error("Error creating workspace:", error);
    this.$alert.show("Failed to create workspace. Please try again.");
  } finally {
    this.$loader.hide();
  }
},
// Reset form fields after workspace creation
resetFormFields() {
  this.brandName = "";
  this.website = "";
  this.businessDescription = "";
  this.countryCode = ""; // Reset to empty or default
  this.brandLogo = null;
  this.primaryEmail = "";
  this.sendWeeklyReport = false;
  this.phone_number = "";
  this.sendWeeklyReportonphone = false;
} ,
    async checkWorkspaceLimit() {
  try {
    const userData = (await getDoc(doc(colUsers, this.currentUID))).data();
    const monthly_limit = userData.addon_monthly_credits?.brands || 0;
    let plan_data = (await getDoc(doc(flyplans, userData?.fly_plan))).data();
    let limit = plan_data?.limits?.brands || 0;
    limit += monthly_limit;

    const workspaceRef = collection(
      db,
      "users",
      this.currentUID,
      "fly_workspaces"
    );
    const workspaceSnapshot = await getDocs(workspaceRef);
    const workspaces = workspaceSnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(doc => !doc.admin);
    const totalWorkspaces = workspaces.length;
    if (totalWorkspaces < limit) {
      await this.populateWorkspaceFields(); // Ensure this is called before opening the dialog
      this.dialog = true; // Open the dialog
    } else {
      this.limitDialog = true;
    }
  } catch (error) {
    console.error("Error checking workspace limit: ", error);
    this.$alert.show(
      "Failed to check workspace limit. Please try again."
    );
  }
}
,
    convertId(id) {
      // Split the string by '/'
      const parts = id.split('/');
      // Get the last part (default) and the second part (user ID)
      const lastPart = parts[parts.length - 1];
      const userId = parts[1];
      // Combine them with '__'
      const result = `${lastPart}__${userId}`;
      return result;
    },
    async listenUsers() {
      const vm = this;
      try {
          // Fetch user document
          const userDoc = (await getDoc(doc(colUsers, this.uid))).data();
          const userFlyPlan = await userDoc?.fly_plan;
          const allowedPlans = process.env.VUE_APP_WK_PLANS.split(",").map(
              (plan) => plan.trim()
          );
          this.shouldRenderMenu = allowedPlans.includes(userFlyPlan);
          
          // Fetch and listen for changes in user workspaces
          this.unsubscribe = onSnapshot(getWorkspaceRef(this.uid), (snapshot) => {
              let userWorkspaces = mapDocs(snapshot.docs);

              // Initialize workspaces array
              let workspaces = [...userWorkspaces].filter(workspace => !workspace.storeWorkspace).map((i) => {
                  return {
                      id: `${i.id}__${this.uid}`,
                      name: i?.name,
                      storeWorkspace:i?.storeWorkspace||null,
                      businessDescription: i?.businessDescription||'',
                      phone_number: i?.phone_number||'',
                      primary_email: i?.primary_email||'',
                      websiteLink: i?.websiteLink||'', 
                      wid: i.id,
                      uid: this.uid,
                      type: "user",
                      logo_original: i?.logo_original,
                  };
              });

              // Set current workspace if not already set
              let localWorkspace = localStorage.getItem("CURRENT_WORKSPACE");
              if (!localWorkspace || localWorkspace === "null" || localWorkspace === "") {
                  let settingWorkspace = workspaces.find((w) => w.wid == "default");
                  this.$store.commit("SET_CURRENT_WORKSPACE", settingWorkspace);
                  localStorage.setItem("CURRENT_WORKSPACE", JSON.stringify(settingWorkspace));
                  localStorage.setItem("CURRENT_WORKSPACE_ID", settingWorkspace.id);
              }

              // Listen for changes in granted workspaces using onSnapshot
                this.unsubscribe1 = onSnapshot(getSharedWorkspaceRef(this.uid), async (snapshot) => {
                  let grantedWorkspaces = mapDocs(snapshot.docs);
                  snapshot.docChanges()?.forEach((change) => {
                    if (change.type === "modified") {
                      console.log("Document updated: ", change.doc.data());
                      const currWS = JSON.parse(localStorage.getItem('CURRENT_WORKSPACE'));
                      currWS.role = change.doc.data()?.role
                      localStorage.setItem("CURRENT_WORKSPACE",JSON.stringify(currWS));
                      this.$nextTick(() => {
                        location.reload();
                      });
                    }
                  });

                  // Fetch the shared workspaces data
                  let requests = grantedWorkspaces.map((i) =>
                      getDoc(getWorkspaceDocRef(i.owner, i.wid))
                  );
                  let sharedWorkspaces = (await Promise.allSettled(requests)).map(
                      (i) => i.value
                  );
                  sharedWorkspaces = sharedWorkspaces.filter((i) => i.data() != null);

                  // Merge user and shared workspaces
                  let updatedWorkspaces = [...workspaces];

                  for (let workspace of grantedWorkspaces) {
                      let item = sharedWorkspaces.find((i) => this.convertId(i.ref.path) == workspace.id);
                      if (item?.data()) {
                          updatedWorkspaces.push({
                              id: `${workspace.wid}__${workspace.owner}`,
                              name: item.data().name,
                              businessDescription: item.data()?.businessDescription||'',
                              phone_number: item.data()?.phone_number||'',
                              primary_email: item.data()?.primary_email||'',
                              websiteLink: item.data()?.websiteLink||'', 
                              wid: workspace.wid,
                              uid: workspace.owner,
                              role: workspace.role,
                              type: "shared",
                              logo_original: item.data().logo_original,
                          });
                      }
                  }

                  // Sort workspaces by name
                  const localWorkspaceId = (JSON.parse(localWorkspace))?.id;
                  const checkDeletedShared = updatedWorkspaces.find((w) => w.id == localWorkspaceId);
                  if (!checkDeletedShared && localWorkspaceId) {
                      const UserDefaultWS = updatedWorkspaces.find((w) => w.id == `default__${this.uid}`);
                      this.changeWorkspace(UserDefaultWS);
                  }
                  if (this.$route?.params?.invite_id) {
                      const invitedWorkspace = updatedWorkspaces.find(w => w.uid === this.$route.params.invite_id);
                      if (invitedWorkspace) {
                          this.changeWorkspace(invitedWorkspace);
                      }
                      if (this.$route.params.invite_id !== null) {
                          const updatedParams = { ...this.$route.params, invite_id: null };
                          this.$router.replace({ name: this.$route.name, params: updatedParams });
                      }
                  }
                  updatedWorkspaces = updatedWorkspaces.sort((a, b) => a.name?.localeCompare(b.name));

                  // Update workspaces
                  this.workspaces = updatedWorkspaces;
                  vm.isLoading = false;
              });
          });
      } catch (error) {
          this.handleError(error);
      }
      /*
      let workspaces = {};
      let index = 0;
      const localStorageWID = localStorage.getItem("CURRENT_WORKSPACE_ID");
      let currentWID = localStorageWID || "default";
      console.log(currentWID, "this is current WID");
      const userDoc = (await getDoc(doc(colUsers, this.uid))).data();
      const userFlyPlan = await userDoc.fly_plan;
      const allowedPlans = process.env.VUE_APP_WK_PLANS.split(",").map((plan) =>
        plan.trim()
      );
      this.shouldRenderMenu = allowedPlans.includes(userFlyPlan);
    
      let workspaceRef = collection(db, "users", this.uid, "fly_workspaces");
      const subcollectionsSnapshot = await getDocs(workspaceRef);
      subcollectionsSnapshot.forEach((subcollectionDoc) => {
        const workspaceId = subcollectionDoc.id;
        const workspaceData = subcollectionDoc.data();
    
        workspaces[index] = { id: workspaceId, name: workspaceData.name };
        index++;
      });
    
      // Fetch workspaces from the workspaces_granted collection
      let grantedWorkspaceRef = collection(
        db,
        "users",
        this.uid,
        "workspaces_granted"
      );
      const grantedWorkspaceSnapshot = await getDocs(grantedWorkspaceRef);
      if (!grantedWorkspaceSnapshot.empty) {
        for (const grantedDoc of grantedWorkspaceSnapshot.docs) {
          const grantedWorkId = grantedDoc.id;
          const { wid, senderId } = this.checkWorkspace(grantedWorkId);
          const grantedWorkspaceData = (
            await getDoc(doc(colUsers, senderId, "fly_workspaces", wid))
          ).data();
          workspaces[index] = {
            id: grantedWorkId,
            name: grantedWorkspaceData.name,
          };
          index++;
        }
      }
    
      const curr_uid = localStorage.getItem("CURRENT_UID");
      let notUserwid;
      if (this.currentOriginalUID != curr_uid) {
        notUserwid = currentWID;
        currentWID = `${currentWID}__${curr_uid}`;
      }
      // console.log(currentWID, "this is printed");
      // console.log(workspaces, "this workspaces is printed");
    
      this.$store.commit("SET_ALL_WORKSPACES", workspaces);
      vm.workspaces = workspaces;
    
      let workspace = Object.values(workspaces).find(
        (workspace) => workspace.id === currentWID
      );
      vm.isLoading = false;
      console.log(workspace, "this outside founded workspace");
      if (workspace) {
        console.log(workspace, "this inside founded workspace");
        localStorage.setItem("CURRENT_WORKSPACE_NAME", workspace.name);
        localStorage.setItem("CURRENT_WORKSPACE_ID", notUserwid || currentWID);
        this.$store.commit(
          "SET_CURRENT_WORKSPACE_ID",
          notUserwid || currentWID
        );
        this.$store.commit("SET_CURRENT_WORKSPACE", workspace);
      }
      vm.isLoading = false;
      */
    },
    async fetchGlobalStores() {
      try {
        // console.log("Fetching global stores - starting");
        const uid = this.currentUID;
        const wid = this.WID;
        
        if (!uid || !wid) {
          console.error('Missing uid or wid:', { uid, wid });
          return;
        }

        // console.log("Fetching global stores - querying:", { uid, wid });
        const storeRef = collection(db, "users", uid, "fly_workspaces");
        const storeQuery = query(storeRef, where("admin", "==", wid));
        const querySnapshot = await getDocs(storeQuery);
        
        // console.log("Fetching global stores - query results:", { count: querySnapshot.size });
        
        const stores = [];
        querySnapshot.forEach((doc) => {
          let storeData = doc.data();
          // Include all store workspaces regardless of Google Business Profile connection
          if (storeData.storeWorkspace && storeData.admin === wid) {
            storeData.id = doc.id;
            storeData.verification_state = storeData?.gmbProfile?.verificationState;
            // Add verification state and tooltip message
            if (storeData.verification_state) {
              storeData.verification_state = storeData.verification_state;
            } else {
              storeData.verification_state = 'STATE_UNSPECIFIED';
            }
            
            // Set isSelectable based on verification state and shallowConnect
            if (storeData.verification_state === 'COMPLETED' && !storeData.shallowConnect) {
              storeData.isSelectable = true;
            } else {
              storeData.isSelectable = false;
            }
            
            // Add tooltip message based on verification state and shallowConnect
            if (storeData.shallowConnect) {
              storeData.tooltipMessage = 'Connect Google Business Profile to view analytics';
            } else {
              switch (storeData.verification_state) {
                case 'COMPLETED':
                  storeData.tooltipMessage = 'GMB Verified';
                  break;
                case 'PENDING':
                  storeData.tooltipMessage = 'GMB Verification Pending';
                  break;
                case 'FAILED':
                  storeData.tooltipMessage = 'GMB Verification Failed';
                  break;
                default:
                  storeData.tooltipMessage = 'GMB Not Verified';
              }
            }
            
            stores.push(storeData);
          }
        });

        console.log('Fetched global stores - processed:', { count: stores.length});
        
        if (stores.length === 0) {
          console.warn('No stores found for this workspace');
        }
        
        this.$store.commit('SET_GLOBAL_STORES', stores);
      } catch (error) {
        console.error('Error fetching global stores:', error);
      }
    },
  },
  mounted() {

    onAuthStateChanged(auth, async (user) => {
      if (this.subscribe) this.subscribe();
      if (user) {
        await this.listenUsers();
        await this.fetchGlobalStores();
      }
    });
    this.initCountries();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.unsubscribe1) this.unsubscribe1();
  }
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 2px !important;
  margin: 2px !important;
}

.workspace-list-standard { /* Changed class name */
  max-height: 500px;
  overflow-y: auto; /* Changed from scroll to auto */
  background-color: #FFFFFF !important; /* Standard white background */
}

/* Removed custom scrollbar styles for a more standard look */
/* ::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 9px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(230, 229, 229, 0.2);
  border-radius: 6px;
} */

/* Using Vuetify standard active class or simple primary text for selection */
/* .selected-workspace {
  background-color: rgba(51, 58, 72, var(--tw-bg-opacity)) !important;
  border-radius: 20rem;
} */

.v-list-item--link:before {
  display: none !important;
}

/* .workspace-list {
  max-height: 500px;
  overflow-y: scroll;
  background-color: #1C2434 !important; 
} Remove this specific dark style */ 

.primary-email-input .v-text-field__slot {
  height: 20px;
}

.v-text-field input {
  padding: 0px;
}
</style>